/**
 * @generated SignedSource<<7717bc12e0600bd943463d5bacf25e67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AnsweringTypeV2 = "allowMultipleAnswersAllCorrectMustBeGiven" | "allowMultipleAnswersOnlySomeCorrectMustBeGiven" | "allowOnlyOneAnswer" | "%future added value";
export type ElementStateKind = "Input" | "InputAndIsCorrect" | "ShowAnswer" | "Untouched" | "UntouchedAndPreviouslyIncorrect" | "%future added value";
export type TypeDefinitionType = "branch" | "content" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RightFrameMultipleChoiceElementPart_ContentSubmissionFragment$data = {
  readonly definition: {
    readonly currentElementState?: {
      readonly checkedAnswerIndices?: ReadonlyArray<number>;
      readonly element?: {
        readonly answerOptions?: ReadonlyArray<{
          readonly answer: string;
        }>;
        readonly answeringType?: AnsweringTypeV2;
        readonly id: string;
        readonly question?: string;
        readonly " $fragmentSpreads": FragmentRefs<"wissenwirktMultiplechoiceElementDisplay_MultipleChoiceElementV2Fragment">;
      };
      readonly kind: ElementStateKind;
    } | null;
    readonly progress?: {
      readonly currentElementIndex?: number;
      readonly isAtLastElement?: boolean;
      readonly numElements?: number;
      readonly percentage: number;
    };
  };
  readonly id: string;
  readonly learnOpportunity: {
    readonly id: string;
    readonly typeDefinition: {
      readonly definitionType: TypeDefinitionType;
      readonly extension?: {
        readonly configConsequences?: {
          readonly isBlockedPermanentlyAfterNumFailedTries: number | null;
          readonly isBlockedTemporarilyForNumDaysAfterOneFailedTry: number | null;
          readonly percentageRequiredToPass: number | null;
        };
      };
    };
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectContentElementContainer_ContentSubmissionFragment">;
  readonly " $fragmentType": "RightFrameMultipleChoiceElementPart_ContentSubmissionFragment";
};
export type RightFrameMultipleChoiceElementPart_ContentSubmissionFragment$key = {
  readonly " $data"?: RightFrameMultipleChoiceElementPart_ContentSubmissionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RightFrameMultipleChoiceElementPart_ContentSubmissionFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "AnswerOptionWithoutCorrect",
  "kind": "LinkedField",
  "name": "answerOptions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "answer",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "wissenwirktMultiplechoiceElementDisplay_MultipleChoiceElementV2Fragment"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RightFrameMultipleChoiceElementPart_ContentSubmissionFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "LearnOpportunityV2",
      "kind": "LinkedField",
      "name": "learnOpportunity",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "typeDefinition",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "definitionType",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "extension",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ContentConfigConsequences",
                          "kind": "LinkedField",
                          "name": "configConsequences",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "percentageRequiredToPass",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isBlockedPermanentlyAfterNumFailedTries",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isBlockedTemporarilyForNumDaysAfterOneFailedTry",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "type": "LearnContentExtensionImpl",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "LearnOpportunityELearningContentTypeDefinition",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "progress",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "percentage",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isAtLastElement",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "numElements",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currentElementIndex",
                      "storageKey": null
                    }
                  ],
                  "type": "ActiveELearningContentSubmissionProgress",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "currentElementState",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "element",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "question",
                              "storageKey": null
                            },
                            (v1/*: any*/),
                            (v2/*: any*/)
                          ],
                          "type": "MultipleChoiceLearnElement",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "UntouchedElementState",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "element",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v1/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "answeringType",
                              "storageKey": null
                            },
                            (v2/*: any*/)
                          ],
                          "type": "MultipleChoiceLearnElement",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "checkedAnswerIndices",
                      "storageKey": null
                    }
                  ],
                  "type": "MultipleChoiceInputElementState",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ActiveELearningContentSubmissionDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectContentElementContainer_ContentSubmissionFragment"
    }
  ],
  "type": "ContentSubmission",
  "abstractKey": null
};
})();

(node as any).hash = "5c2d06cdc42111de856f019ce8eab9cc";

export default node;
